export function getISOWeekNumber(date = new Date()) {
    const dayOfWeek = date.getDay() === 0 ? 7 : date.getDay();
    const nearestThursday = new Date(date);
    nearestThursday.setDate(date.getDate() + (4 - dayOfWeek));
  
    const jan1 = new Date(nearestThursday.getFullYear(), 0, 1);
    const jan1DayOfWeek = jan1.getDay() === 0 ? 7 : jan1.getDay();
  
    const firstISOWeekStart = new Date(jan1);
    firstISOWeekStart.setDate(
      jan1.getDate() + (jan1DayOfWeek <= 4 ? 1 - jan1DayOfWeek : 8 - jan1DayOfWeek)
    );
  
    const daysSinceFirstISOWeek = Math.floor(
      (nearestThursday - firstISOWeekStart) / (24 * 60 * 60 * 1000)
    );
  
    return Math.ceil((daysSinceFirstISOWeek + 1) / 7);
  }
  